import appService from '../js/appservice/index'
import { getErrorMessage } from '../js/helpers/axioshelper'

const state = {
  normGroups: []
}

const getters = {
  normGroups: state => state.normGroups
}

const actions = {
  getNormGroups(context) {
    return new Promise((resolve, reject) => {
      appService.normgroups
        .getNormGroups()
        .then(data => {
          context.commit('getNormGroups', data)
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getNormGroup(context, normGroupId) {
    return new Promise((resolve, reject) => {
      appService.normgroups
        .getNormGroup(normGroupId)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addNormGroup(context, normGroup) {
    return new Promise((resolve, reject) => {
      appService.normgroups
        .addNormGroup(normGroup)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateNormGroup(context, normGroup) {
    return new Promise((resolve, reject) => {
      appService.normgroups
        .updateNormGroup(normGroup)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteNormGroup(context, normGroupId) {
    return new Promise((resolve, reject) => {
      appService.normgroups
        .deleteNormGroup(normGroupId)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}

const mutations = {
  getNormGroups(state, data) {
    state.normGroups = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
